module.exports = __webpack_public_path__ + "img/fish3.79fbfa80.png";